export class CardDefaultUpdateDto {
  constructor(data) {
    this.payment_profile_id = data.payment_profile_id;
    this.group_admin_id = data.group_admin_id;
  }
}
